export const config = {
  exampleryServerURI: process.env.REACT_APP_EXAMPLERY_SERVER_URI || 'https://api.examplery.io/graphql/',
  exampleryServerWSURI: process.env.REACT_APP_EXAMPLERY_SERVER_WSURI || 'wss://ws.examplery.io',
  orgDomain: process.env.REACT_APP_EXAMPLERY_ORGDOMAIN || 'examplery.com'
} 